export const getWhatsAppLink = (phone, message) => {
  if (typeof phone === "string") {
    let formattedPhone = '';
    switch (true) {
      case phone.startsWith('0'):
        formattedPhone = `972${phone.slice(1)}`
      break;
      case phone.startsWith('+'):
        formattedPhone = `${phone.slice(1)}`
      break;
      default: formattedPhone = phone
    }

    return `https://wa.me/${formattedPhone}?text=${message}`;
  } else return null
};

export const formattingPrice = (value, showSign = false) => {
  if (value) {
    const sign = (showSign) ? ` ₪` : '';
    return Boolean(value) ? `${value.toLocaleString('he')}${sign}` : '';
  }
};